var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.837H31.4488C31.0476 10.3486 30.4379 8.94609 29.6516 7.66309H16V11.837Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04045 28.5323H25.96C27.4202 27.3693 28.6724 25.9567 29.6518 24.3584H2.34863C3.32807 25.9566 4.58032 27.3693 6.04045 28.5323Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56545 3.88184C4.30757 4.96502 3.22013 6.24059 2.34863 7.66284H5.56545V3.88184Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0109C16 14.3811 16 13.0172 16 11.8369H9.73913V16.0109H5.56519V11.8369H0.551188C0.1925 13.1678 0 14.5667 0 16.0109C0 17.455 0.1925 18.8539 0.551188 20.1848H31.4489C31.8075 18.8539 32 17.455 32 16.0109H16Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C13.7782 0.0107422 11.6623 0.464055 9.73914 1.28249V7.66293H16C16 6.20593 16 4.96674 16 3.48899H25.9598C23.2266 1.31224 19.7656 0.0107422 16 0.0107422Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGreece);
export default __webpack_public_path__ + "static/media/flag_greece.d82800b8c1eadc49eaa3d519e9092ae0.svg";
export { ForwardRef as ReactComponent };